import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OfflineModal {
    isOpen: boolean;
    sideNavIconClickedName: string;
}
const initialState: OfflineModal = {
    isOpen: false,
    sideNavIconClickedName: '',
};
const offlineModalSlice = createSlice({
    name: 'offlineModal',
    initialState,
    reducers: {
        setOfflineModalOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setSideNavIconClickedName: (state, action: PayloadAction<string>) => {
            state.sideNavIconClickedName = action.payload;
        },
    },
});

export const { setOfflineModalOpen, setSideNavIconClickedName } =
    offlineModalSlice.actions;
export default offlineModalSlice.reducer;
